import { render, staticRenderFns } from "./PCCopyright.vue?vue&type=template&id=1dcb84e4&"
import script from "./PCCopyright.vue?vue&type=script&lang=js&"
export * from "./PCCopyright.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports